import React from 'react';
import { useAudio } from './AudioContext';
import './style.scss';



export default function MuteButton() {
    const { isMuted, toggleMute } = useAudio();

    return (
        <button 
            className={`btnMute ${isMuted ? 'muted' : ''}`} 
            onClick={toggleMute}
        >
            {isMuted ? (
                <>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 0 50 50"><path fill="black" d="m35.735 24.4 4.542-4.548a1.001 1.001 0 0 0-1.416-1.414l-4.545 4.552-4.545-4.552a1.001 1.001 0 0 0-1.416 1.414l4.542 4.548-4.542 4.547a1.001 1.001 0 0 0 1.416 1.414l4.545-4.551 4.545 4.551a1 1 0 0 0 1.416-1.414L35.735 24.4zM22.642 38.06a1.002 1.002 0 0 0 1-1v-24c0-.379-.214-.725-.552-.895a1.005 1.005 0 0 0-1.047.094l-8.2 6.134H9.569a1 1 0 0 0-1 1v11.334a1 1 0 0 0 1 1h4.273l8.2 6.134c.177.131.388.199.6.199zm-1-2.997-6.867-5.137a1.002 1.002 0 0 0-.599-.199H10.57v-9.334h3.606c.216 0 .426-.07.599-.199l6.867-5.137v20.006z"/></svg>
                </>
            ) : (
                <>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path fill="black" d="M37.341 37.567a1 1 0 0 0 .724-.31c2.852-2.987 4.487-7.332 4.487-11.922 0-4.589-1.636-8.934-4.486-11.921a1.001 1.001 0 0 0-1.447 1.381c2.5 2.619 3.934 6.461 3.934 10.54 0 4.08-1.434 7.922-3.935 10.541a1.001 1.001 0 0 0 .723 1.691z"/><path fill="black" d="M34.016 34.482a.998.998 0 0 0 .698-.284c2.225-2.172 3.501-5.401 3.501-8.861 0-3.461-1.276-6.69-3.501-8.862a1 1 0 1 0-1.396 1.432c1.841 1.797 2.897 4.506 2.897 7.431s-1.057 5.633-2.897 7.43a1 1 0 0 0 .698 1.714z"/><path fill="black" d="M30.084 29.571a1.001 1.001 0 0 0 1.284 1.535c1.572-1.314 2.511-3.472 2.511-5.77 0-2.333-.961-4.508-2.57-5.82a1.001 1.001 0 0 0-1.263 1.551c1.148.936 1.834 2.532 1.834 4.27-.002 1.713-.673 3.296-1.796 4.234zM24.03 12.536l-8.203 6.134h-4.275a1 1 0 0 0-1 1v11.334a1 1 0 0 0 1 1h4.275l8.203 6.134a.998.998 0 0 0 1.047.094c.338-.17.552-.516.552-.895v-24c0-.379-.214-.725-.552-.895a1.007 1.007 0 0 0-1.047.094zm-.401 22.805-6.87-5.138a1.002 1.002 0 0 0-.599-.199h-3.608V20.67h3.608c.216 0 .426-.07.599-.199l6.87-5.138v20.008z"/></svg>
                </>
            )
        }
        </button>
    )
}
           